import React, { useEffect } from 'react';
import Mark from 'mark.js';

import { Wrapper } from './search-results-sidebar.styles';

import Item from './item';

const SearchResultsSidebar = ({ searchResults, textByPages, query }) => {
  useEffect(() => {
    const markInstance = new Mark(document.querySelectorAll('.search-result'));
    markInstance.unmark({
      done: () => {
        markInstance.mark(query, {
          accuracy: 'exactly',
          debug: true,
          ignorePunctuation: ':;.,-–—‒_(){}[]!\'"+='.split(''),
          acrossElements: true,
        });
      },
    });
    if (!query || searchResults.length === 0) {
      markInstance.unmark();
    }
  }, [searchResults, query]);

  return (
    <Wrapper>
      {searchResults &&
        searchResults.length > 0 &&
        searchResults.map((result, index) => {
          const metadata = result.matchData.metadata;
          const position =
            result.matchData.metadata[Object.keys(metadata)[0]].text
              .position[0];
          const positionStart = position[0] - 60 > 0 ? position[0] - 60 : 0;
          const positionEnd =
            position[0] + position[1] + 60 <
            textByPages[result.ref - 1].text.length
              ? position[0] + position[1] + 60
              : textByPages[result.ref - 1].text.length;
          return (
            <Item
              key={index}
              page={result.ref}
              text={
                textByPages[result.ref - 1].text.slice(
                  positionStart,
                  positionEnd,
                ) + '…'
              }
            ></Item>
          );
        })}
    </Wrapper>
  );
};

export default SearchResultsSidebar;
